import Swiper from 'swiper';

class ListNews {
  slider: Swiper
  breakpoint

  constructor() {
    this.breakpoint = window.matchMedia( '(min-width:991px)' );
    let sN = this.sliderNews();
    this.breakpointChecker(sN);
  }

  breakpointChecker(sN : any) {
    if ( this.breakpoint.matches === true ) {
      if ( sN !== undefined ) {
        sN.destroy( true, true );
      }
    } else if ( this.breakpoint.matches === false ) {
      this.sliderNews();
    }
  }


  sliderNews() {
    this.slider = new Swiper('.ln_slider', {
      slidesPerView: 1.5,
      breakpoints: {
        640: {
          slidesPerView: 2.5,
        },
        992: {
          allowTouchMove: false
        },
      }
    });
  }
}

new ListNews();